import './about.scss';
import Breadcrumb from '../common/Breadcrumb';
import directorImage from '../assets/portraits/director.jpeg';
import { useTranslation } from 'react-i18next';

function About() {
  const { t } = useTranslation();
  const aboutParas = t('about.aboutContentParas', { returnObjects: true }) as string[];
  const values = t('about.values', { returnObjects: true }) as Array<{ title: string; description: string }>;

  return (
    <div className='about-container'>
      <div className='main-content-container'>
        <Breadcrumb />
        
        {/* Director Section */}
        <section className='director-section'>
          <div className='director-image-wrapper'>
            <img src={directorImage} alt='Company Director' className='director-image' />
          </div>
          <div className='director-info'>
            <blockquote className='director-quote'>
              {t('about.directorQuote')}
            </blockquote>
            <div className='director-details'>
              <h3 className='director-name'>Usman</h3>
              <p className='director-title'>Founder &amp; Director</p>
            </div>
          </div>
        </section>

        {/* Company Info Section */}
        <section className='company-section'>
          <h2 className='section-title'>{t('about.ourStoryTitle')}</h2>
          <div className='company-content'>
            {aboutParas.map((para, index) => (
              <p key={index}>{para}</p>
            ))}
          </div>

          <h2 className='section-title'>{t('about.ourMissionTitle')}</h2>
          <div className='company-content'>
            <p>{t('about.ourMissionContent')}</p>
          </div>

          <h2 className='section-title'>{t('about.ourValuesTitle')}</h2>
          <div className='values-grid'>
            {values.map((value, index) => (
              <div className='value-card' key={index}>
                <h4>{value.title}</h4>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default About;
